<template>
  <div class="yhc-ef-item-list--kazai-category-list-wrap">
    <div
      v-for="(subCategories, parentCategoryName) in subCategoriesByParentCategory"
      :key="parentCategoryName"
      class="yhc-ef-item-list--kazai-category-list"
    >
      <div
        class="yhc-ef-item-list--kazai-category-list-title"
        @click="toggleParentCategory(parentCategoryName)"
      >
        {{ parentCategoryName }}
        <span class="yhc-ef-item-list--kazai-category-list-title--icon">
          <ficon
            :type="isParentCategorySelected(parentCategoryName) ? 'minus' : 'plus'"
          />
        </span>
      </div>
      <div
        v-if="isParentCategorySelected(parentCategoryName)"
        class="yhc-ef-item-list--kazai-category-list--sub-categories"
      >
        <div
          v-for="cat in subCategories"
          :key="cat.id"
          class="yhc-ef-item-list--kazai-category-list--sub-categories--item"
          @click="selectKazaiCategory(cat.id)"
        >
          <div class="yhc-ef-item-list--kazai-category-list--sub-categories--item--inner">
            <div
              class="yhc-ef-item-list--kazai-category-list--sub-categories--item--name"
            >
              {{ cat.name }}
            </div>
            <img
              v-if="cat.thumbnail"
              :src="buildImgixUrl(cat.thumbnail, { w: 980 })"
              class="yhc-ef-item-list--kazai-category-list--sub-categories--item--img"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.yhc-ef-item-list--kazai-category-list-wrap {
  --item-width: 160px;
  display: flex;
  flex-direction: column;
  gap: var(--yhc-pad);
  .yhc-ef-item-list--kazai-category-list {
    box-shadow: var(--bs-card-box-shadow);
    .yhc-ef-item-list--kazai-category-list-title {
      border-top-left-radius: var(--yhc-border-radius);
      border-top-right-radius: var(--yhc-border-radius);
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
      background-color: var(--bs-gray-100);
      padding: var(--yhc-pad-sm);
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: var(--yhc-font-lg);
      font-weight: bold;
      .yhc-ef-item-list--kazai-category-list-title--icon {
        background: var(--yhc-color);
        color: white;
        width: 1.5em;
        height: 1.5em;
        font-size: var(--yhc-font-sm);
        border-radius: 1em;
        margin-left: 0.5em;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .yhc-ef-item-list--kazai-category-list--sub-categories {
      background-color: var(--bs-gray-300);
      gap: var(--yhc-pad);
      padding: var(--yhc-pad);

      flex-wrap: wrap;
      width: 100%;
      display: grid;
      margin: 0 auto 16px;
      grid-template-columns: repeat(auto-fit, 150px);
      @media screen and (max-width: 400px) {
        grid-template-columns: repeat(auto-fit, 140px);
      }
      justify-content: center;

      .yhc-ef-item-list--kazai-category-list--sub-categories--item {
        background: white;
        padding: var(--yhc-pad);
        text-align: center;
        border-radius: var(--yhc-border-radius);
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
        .yhc-ef-item-list--kazai-category-list--sub-categories--item--img {
          max-width: 100%;
        }
        .yhc-ef-item-list--kazai-category-list--sub-categories--item--name {
          font-weight: bold;
          font-size: var(--yhc-font-sm);
          padding-bottom: var(--yhc-pad-sm);
        }
      }
    }
  }
}
</style>

<script lang="ts">
import { defineComponent, ref, computed, inject } from 'vue'
import { YhcEstimateFormFrontService } from '../../YhcEstimateFormFrontService'

export default defineComponent({
  name: 'YhcEFItemListKazaiCategoryList',
  emits: ['selectKazaiCategory'],
  setup(props, { emit }) {
    const YhcEstimateFormFrontServiceInstance = inject(
      'YhcEstimateFormFrontServiceInstance',
    ) as YhcEstimateFormFrontService
    const selectedParentCategory = ref('')

    const subCategoriesByParentCategory = computed(
      () => YhcEstimateFormFrontServiceInstance.subCategoriesByParentCategory,
    )

    const isParentCategorySelected = (parentCategoryName: string) => {
      if (selectedParentCategory.value === '') {
        return parentCategoryName === Object.keys(subCategoriesByParentCategory.value)[0]
      }
      return parentCategoryName === selectedParentCategory.value
    }

    const toggleParentCategory = (parentCategoryName: string) => {
      selectedParentCategory.value =
        selectedParentCategory.value === parentCategoryName ? '' : parentCategoryName
    }

    const selectKazaiCategory = (categoryId: number) => {
      emit('selectKazaiCategory', categoryId)
    }

    const buildImgixUrl = (url: string, params: Record<string, any>) => {
      return $core.$imgix.buildUrl(url, params)
    }

    return {
      subCategoriesByParentCategory,
      isParentCategorySelected,
      toggleParentCategory,
      selectKazaiCategory,
      buildImgixUrl,
    }
  },
})
</script>
